// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "EditLink-module--bx--text-truncate--end--uI0cF";
export var bxTextTruncateFront = "EditLink-module--bx--text-truncate--front--HxjcS";
export var link = "EditLink-module--link--IDrl1";
export var row = "EditLink-module--row--BEmSX";